import { Permission } from '../types/user';

const permissionLabelCache = new Map<Permission, string>();

/** Populate label cache from GET /admin/permissions response. */
export function setPermissionLabelCatalog(
  grouped: Record<string, { value: number; name: string }[]>
): void {
  permissionLabelCache.clear();
  for (const entries of Object.values(grouped)) {
    for (const entry of entries ?? []) {
      if (typeof entry.value === 'number' && entry.name) {
        permissionLabelCache.set(entry.value as Permission, entry.name);
      }
    }
  }
}

export function resolveUserPermissions(user: { permissions: Permission[] } | null): Permission[] {
  if (!user) return [];
  return user.permissions;
}

export function permissionLabel(permission: Permission): string {
  return permissionLabelCache.get(permission) ?? Permission[permission] ?? String(permission);
}
